import Button from 'react-bootstrap/Button'
function Feedback({ direction, language }) {
    function openurl(url) {
        window.location.href = url
    }
    return (
            <Button className="position-absolute top-18 end-0 primary-bg z-1 text-uppercase ff-gothambold border-0 rounded-start-pill mb-4" dir={direction} onClick={() => openurl("https://forms.office.com/r/i6gzJYEWR4")}>
                <img src="../assets/feedback.webp" alt="" className='p-0 feedback-icon mx-1' />
                {language === "AR" ? 'تعليق' : 'Feedback'}
            </Button>
    );
}

export default Feedback;